import { useSyncExternalStore } from 'react'

/*
 * THE TAB EACH AGENT WORKED IN LAST, as its Clean View read it from the conversation
 * (browserActivity.ts lastTabTouched) — for the corner of its session (AgentTabCorner),
 * which is drawn outside that view, over the terminal too, and has no conversation of its
 * own to read. Kept for as long as the app is open; a view that scrolled back to a part with
 * no browser commands in it says nothing new and takes nothing away.
 */
const last = new Map<string, string>()
const listeners = new Set<() => void>()

/** An agent by its channel hash and the machine it is on — a name is unique on one machine only. */
export const agentKey = (a: { hash: string; device_id?: string | null }) => `${a.hash}|${a.device_id ?? ''}`

export function noteLastTab(key: string, tab: string | null): void {
  if (!tab || last.get(key) === tab) return
  last.set(key, tab)
  for (const fn of listeners) fn()
}

/**
 * Whether these blocks are THIS agent's window. Clean View keeps its view from one agent to the
 * next, and the first commit after another agent is opened still holds that agent's window:
 * noted then, the agent just opened was given the other one's last tab (the review of
 * 2026-10-15).
 */
export function windowIsTheirs(before: { key: string; blocks: unknown } | null, key: string, blocks: unknown): boolean {
  return !(before && before.key !== key && before.blocks === blocks)
}

export function useLastTab(key: string): string | null {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn)
      return () => {
        listeners.delete(fn)
      }
    },
    () => last.get(key) ?? null,
  )
}
